import React, { useEffect, useState, useContext, useCallback } from 'react'
import { MusicPlayerContext } from '../../context/MusicPlayerContext'
import { getSongURL, getSongDetailsById, fetchSimilarSongs, getSimilarPlaylists, addToFavorites } from '../../utils/api'
import { GlobalMusicContext } from '../../context/GlobalMusicContext'
import { Link, useHistory } from 'react-router-dom'
import { useMusicPlayer } from '../../hooks/useMusicPlayer'
import { Loading } from '../helpers/Loading'
import { AlertMssg } from '../helpers/AlertMssg'
import { getDateFormat } from '../../utils/helper-functions'
import { Box, Stack, Text, Heading } from '@chakra-ui/react'
import { RiUserStarLine, RiAlbumLine, RiMusicLine, RiCalendarLine } from 'react-icons/ri'

export const TrackDetails = ( { match } ) => {
  const { params: { id } } = match
  const [{ currentTrack }, dispatch] = useContext( GlobalMusicContext )
  // eslint-disable-next-line
  const [state, setState] = useContext( MusicPlayerContext )
  const [loading, setLoading] = useState( false )
  const [alertMssg, setAertMssg] = useState( false )
  const [similarTracks, setSimilarTracks] = useState( [] )
  const [similarPlaylists, setSimilarPlaylists] = useState( [] )
  const history = useHistory()

  const setCurrentTrack = useCallback( data => {
    dispatch( { type: "setCurrentTrack", snippet: data } )
  },
    [dispatch] )

  useEffect( () => {
    setLoading( true )
    const songDetails = async () => {
      const songArr = await getSongDetailsById( id )
      let song = songArr[0]
      const urlData = await getSongURL( id )
      let url = urlData.url
      if ( url === null ) {
        setAertMssg( true )
      }
      setLoading( false )
      let newTrack = { ...song, url }
      setCurrentTrack( newTrack )
      let tracksArr = [...state.tracks]
      tracksArr.push( newTrack )
      state.tracks = tracksArr
      setState( state => ( { ...state } ) )
    }
    songDetails( id )
    // eslint-disable-next-line
  }, [id] )
  /**    const addSongToPlayQueue = ( id ) => {
      let curr = currentSongs?.find( ( t ) => t.id === id )
      let index = trackList.findIndex( ( curr ) => curr?.id === id )
      // console.log( index, "index of trackList", id )
      if ( index === -1 ) {
          trackList?.push( { ...curr } )
      } else {
          setMssg( true )
          return alert( "Already in Queue" )
      }
  }
  */
  // useEffect( () => {
  //     const similarPlaylists = async () => {
  //         const song = await addToFavorites( id )
  //         const result = await song.data
  //         console.log( result, "addToFavorites-song" )
  //     }
  //     similarPlaylists()
  // }, [id] )

  useEffect( () => {
    // eslint-disable-next-line
    const getSimilarSongs = async ( id ) => {
      const songs = await fetchSimilarSongs( id )
      const playlists = await getSimilarPlaylists( id )
      // console.log( "similar songs/playlists", playlists, songs )
      setSimilarTracks( songs )
      setSimilarPlaylists( playlists )
      return { songs, playlists }
    }
    getSimilarSongs( id )
  }, [id] )

  const handleUnavailable = () => {
    if ( currentTrack.url === null ) {
      setAertMssg( true )
      history.goBack()
    }
  }
  const { trackList, playTrack } = useMusicPlayer()
  let index = trackList.indexOf( currentTrack )
  // console.log( index )
  const artistId = currentTrack?.ar && currentTrack?.ar?.length > 1
    ? currentTrack?.ar.map( ( ar, i ) => {
      let id = ar.id
      currentTrack.ar[i].id = id
      //  console.log( id, "just id" )
      return id
    } )
    : ""
  const idx = artistId && artistId.map( ( { id } ) => id === currentTrack?.ar?.id )

  return (
    <div className="track__details--wrapper">
      <div className="track__details--card">
        {alertMssg ? <AlertMssg
          mssg="Song Unavailable"
          clickHandler={handleUnavailable}
        />
          : null}
        {loading
          ? <Loading />
          : currentTrack
            ? <div key={currentTrack?.id} className="cards__container">
              <div
                className="track__details image__wrapper"
                onClick={() => playTrack( index )}>
                <img
                  src={currentTrack?.al?.picUrl + "?param=280y280"}
                  alt={currentTrack.name}
                  loading="lazy"
                  className="track__details--playSvg"
                />
              </div>
              <Box>
                <Heading
                  fontFamily="subtitle"
                  fontWeight="light"
                  size="md"
                  whiteSpace="nowrap"
                >
                  {currentTrack.name}
                </Heading>
                <Link to={`/album/${currentTrack?.al?.id}`} className="track__details--albumSvg">
                  <Text
                    fontFamily="subtitle"
                    fontWeight="light">
                    <RiAlbumLine mx={2}
                      style={{
                        display: "inline-flex"
                      }}
                    />
                    {currentTrack?.al?.name}
                  </Text>
                </Link>
                <Link to={`/artists/${currentTrack.ar && currentTrack.ar[0].id}`} className="track__details--albumSvg">
                  <Text
                    fontFamily="subtitle"
                    fontWeight="light">
                    <RiUserStarLine mx={0}
                      style={{
                        display: "inline-flex"
                      }}
                    />
                    <RiMusicLine mr={2}
                      style={{
                        display: "inline-flex",
                        width: "0.7em",
                        height: "0.7em",
                        verticalAlign: "text-top",
                        marginLeft: "-1px",
                      }}
                    />
                    {currentTrack?.ar?.map( ( { name } ) => name ).join( ' & ' )}
                  </Text>
                </Link>
                <Text className="track__details--date" fontFamily="subtitle" fontSize="xs">
                  <RiCalendarLine mx={2}
                    style={{
                      display: "inline-flex",
                      // color:"currentColor"
                    }}
                  />
                  {getDateFormat( currentTrack.publishTime && currentTrack.publishTime )}
                </Text>
              </Box>

              <Box fontSize="sm">
                <Heading fontFamily="regular" fontSize="lg" fontWeight="regular">
                  Similar Tracks
                </Heading>
                {similarTracks ? similarTracks?.songs?.map( track => {
                  return (
                    <Link key={track.id} to={`/song/${track.id}`}>
                      <Stack isInline className="track__details--similar">
                        <Text fontFamily="regular" fontSize="sm" fontWeight="light">
                          <RiMusicLine
                            mx={0.5}
                            style={{
                              display: "inline-flex"
                            }}
                          />
                          {" "}
                          {track.name}
                          <br />
                          { /** in Text (at TrackDetails.jsx:171) */}
                          <span fontSize="xs" mr={1}>
                            {track?.artists.length > 1 ? track?.artists.map( ( { name } ) => name ).join( ' & ' ) : track?.artists[0].name}
                          </span>
                        </Text>
                      </Stack>
                    </Link>
                  )
                } )
                  : null
                }
              </Box>
            </div>
            : null
        }
      </div>
    </div>
  )
}